

  const formatFilter = {
    search: 'search',
    createYear: "year",
    month: 'month',
    from: "start_date",
    to: "end_date",
    status: 'status_id',
  }


  const formatSort = {
    name: 'title',
    categoriesCount: 'activityCount'
  }
export {
  formatFilter,
  formatSort
}
